import React from 'react';
import VerifyForm from './VerifyForm';
import { withRouter } from 'react-router-dom';


class VerifyEdit extends React.Component {
    constructor(props){
        super(props);
        this.id = props.match.params.id;
    }

    render(){
        return (
            <div>
                <VerifyForm id={this.id} />
            </div>
        );
    }

}
export default withRouter(VerifyEdit);



// WEBPACK FOOTER //
// ./src/pages/Verify/VerifyEdit.js